const HEADER_HEIGHT = 66;
const BREADCRUMB_NAVIGATION_HEIGHT = 35;
const FOOTER_HEIGHT_PC = 179;
const FOOTER_HEIGHT_SP = 614;
// 現在cssの調整がPC基準で行われているため、PC用の高さのみ定義
const HEADER_AND_FOOTER_HEIGHT_PC = HEADER_HEIGHT + FOOTER_HEIGHT_PC;
const HEADER_BREADCRUMB_FOOTER_HEIGHT_PC =
  HEADER_HEIGHT + BREADCRUMB_NAVIGATION_HEIGHT + FOOTER_HEIGHT_PC;

// TODO: 共通のレイアウト定数を使用するようにする
export const LAYOUT_HEIGHTS = {
  HEADER_HEIGHT,
  BREADCRUMB_NAVIGATION_HEIGHT,
  FOOTER_HEIGHT_PC,
  FOOTER_HEIGHT_SP,
  HEADER_AND_FOOTER_HEIGHT_PC,
  HEADER_BREADCRUMB_FOOTER_HEIGHT_PC,
} as const;
